import { fileManagerRestrictionLocale as e } from "../../widget/file-manager/locale/en_US.js";
import { languagePairLocale as t } from "../../widget/language-pair/locale/en_US.js";
import { calendarLocale as n } from "../calendar/locale/en_US.js";
import { carouselLocale as r } from "../carousel/locale/en_US.js";
import { cascaderLocale as i } from "../cascader/locale/en_US.js";
import { commandLocale as a } from "../command/locale/en_US.js";
import { datePickerLocale as o } from "../date-picker/locale/en_US.js";
import { emptyLocale as s } from "../empty/locale/en_US.js";
import { paginationLocale as c } from "../pagination/locale/en_US.js";
import { sidebarLocale as l } from "../sidebar/locale/en_US.js";
import { tagSelectorLocale as u } from "../tag-selector/locale/en_US.js";
//#region src/components/ui/locale/en_US.ts
var d = {
	locale: "en-US",
	global: {
		cancelText: "Cancel",
		closeText: "Close",
		moreText: "More",
		okText: "OK"
	},
	calendar: n,
	carousel: r,
	cascader: i,
	command: a,
	datePicker: o,
	empty: s,
	pagination: c,
	sidebar: l,
	tagSelector: u,
	languagePair: t,
	useFileManager: e
};
//#endregion
export { d as default };

//# sourceMappingURL=en_US.js.map